module.exports = __webpack_public_path__ + "img/9791191438468.9aa73703.jpg";